<template>
    <div v-loading="loading">
        <div class="search-ctn" style="padding-top: 0; padding-left: 10px; padding-right: 10px">
            <div class="search-name">商品名称：{{ GoodsData.GoodName }}</div>
            <div class="search-name">汽配编码：{{ GoodsData.APCode }}</div>
            <div class="search-name">适用车型：{{ GoodsData.AutoSerise }}</div>
            <div class="search-name">总库存数：{{ GoodsData.Inventory }}</div>
        </div>
        <div class="table-ctn sp-col">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="dataList" :summary-method="getSummaries" show-summary border style="width: 100%; margin-bottom: 10px">
                <el-table-column fixed prop="StorageName" show-overflow-tooltip min-width="200" label="仓库名称">
                    <template slot-scope="scope">
                        {{ scope.row.StorageName }}
                        <span v-if="scope.row.WarehouseType == 1" style="color: #8492a6">(前置仓)</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip min-width="200" prop="ShelfSpaceCode" label="仓位编码"></el-table-column>
                <el-table-column show-overflow-tooltip width="120" prop="Count" label="存放数量"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="100" label="标签规格总数">
                    <template slot-scope="scope">
                        <span v-if="scope.row.LabelCount == 0 || scope.row.WarehouseType == 1">-</span>
                        <el-link v-else type="primary" :underline="false" @click="showLabelData(scope.row.GoodsId)">{{ scope.row.LabelCount }}</el-link>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog :close-on-click-modal="false" title="标签数据" :visible.sync="labelDatasVisible" width="800px" append-to-body>
            <div class="dialog-content" v-if="labelDatasVisible">
                <GoodsLabelDatas :GoodsId="entpGoodsId" @closeDialog="closeLabelDatasDialog"></GoodsLabelDatas>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import GoodsLabelDatas from '@/components/business/goods/goodsLabelDatas';
export default {
    name: '',
    props: ['EntpGoodsId'],
    components: { GoodsLabelDatas },
    data() {
        return {
            entpGoodsId: '',
            loading: false,
            labelDatasVisible: false,
            dataList: [],
            GoodsData: {}
        };
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        getTableData() {
            let that = this;
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetEntpGoodsPositionDatas',
                    data: {
                        GoodsId: that.EntpGoodsId
                    }
                })
                .then(res => {
                    that.GoodsData = res.data;
                    if (res.data.LocationList) {
                        that.dataList = res.data.LocationList;
                    }
                    that.loading = false;
                })
                .catch(() => {
                    that.loading = false;
                });
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 1) {
                    sums[index] = '总在仓数量';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    sums[index] += '';
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        },
        showLabelData(id) {
            if (id) {
                this.entpGoodsId = id;
                this.labelDatasVisible = true;
            }
        },
        closeLabelDatasDialog() {
            this.entpGoodsId = '';
            this.labelDatasVisible = false;
        }
    }
};
</script>
<style lang="less" scoped>
.search-ctn {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    .search-ctn-left {
        display: flex;
    }
    .search-ctn-right {
        display: flex;
        align-items: center;
    }
}
</style>
<style lang="less">
.sp-col {
    .el-table .el-table__cell {
        padding: 0;
    }
}
</style>
